module.exports = __webpack_public_path__ + "img/transfer3.f1a2771a.jpeg";